<mat-autocomplete #elem (opened)="opened()" (closed)="closed()">
  <mat-option *ngFor="let organization of organizations | async" (click)="onSelect(organization)">
    {{ organization.name }}
  </mat-option>
  <app-loader-three-dots class="w-100 d-block text-center" *ngIf="isLoading"></app-loader-three-dots>
</mat-autocomplete>
